import './style.scss';

import { CheckOutlined, ControlOutlined, SearchOutlined } from '@ant-design/icons';
import { Dropdown, Input, Menu } from 'antd';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useDebounce, useMergeState, useUpdateEffect } from '../../../utils/hooks/index';

const SearchBar = (props) => {
  const [state, setState] = useMergeState({
    searchValue: '',
    searchByKey: props.searchBy?.[0]?.value || 'eID',
    searchByTitle: props.searchBy?.[0]?.label || 'eID',
  });

  const searchByItem = useMemo(
    () => _.find(props.searchBy, item => item.value === state.searchByKey),
    [state.searchByKey],
  );


  const onChangeCriteria = ({ key }) => {
    const searchTitle = _.find(props.searchBy, item => item.value === key);
    setState({ searchByKey: key, searchByTitle: searchTitle.label });
    // props.fetchData({ key: state.searchByKey, value: state.searchValue });
  };

  const onChangeSearchValue = (e) => {
    setState({ searchValue: e.target.value });
  };
  const menu = (
    <Menu className="search-menu-wrapper">
      <Menu.ItemGroup className="search-menu-title">
        {
        _.map(props.searchBy, item => (
          <Menu.Item key={item.value} className="search-menu-item" onClick={onChangeCriteria}>
            {
              item.value === state.searchByKey
                ? (
                  <div className="selected">
                    <CheckOutlined className="item-icon" />
                    {item.label}
                  </div>
                )
                : (
                  <div className="icon-placeholder">
                    {item.label}
                  </div>
                )
            }

          </Menu.Item>
        ))
      }
      </Menu.ItemGroup>
    </Menu>
  );

  const renderSearchCriteria = () => {
    if (Array.isArray(props.searchBy) && props.searchBy.length > 1) {
      return (
        <Dropdown className="search-by-criteria" overlay={menu} trigger={['click']} placement="bottomRight">
          <ControlOutlined />
        </Dropdown>
      );
    }
    return null;
  };

  const debouncedSearchTerm = useDebounce(state.searchValue, 300);

  useUpdateEffect(() => {
    props.fetchData({ key: state.searchByKey, value: state.searchValue });
  }, [debouncedSearchTerm]);

  useUpdateEffect(() => {
    setState({ searchValue: '' });
  }, [state.searchByKey]);

  return (
    <Input
      className={classNames('search-bar-wrapper', props.className)}
      prefix={<SearchOutlined />}
      suffix={renderSearchCriteria()}
      value={state.searchValue}
      placeholder={`Search ${state.searchByTitle}`}
      onChange={onChangeSearchValue}
    />
  );
};

SearchBar.defaultProps = {
  className: '',
  searchBy: [],

  fetchData: () => {},
};

SearchBar.propTypes = {
  className: PropTypes.string,
  searchBy: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),

  fetchData: PropTypes.func,
};

export default SearchBar;
